export default __webpack_public_path__ + "static/media/Snd_Q_Starts.c1fb4208.mp3";